type getShortTimeZoneType = () => string

const getShortTimeZone: getShortTimeZoneType = () => {
  const dateStringWithTimeZone = Intl.DateTimeFormat(navigator.language, {
    timeZoneName: 'short',
  }).format(new Date())

  const shortTimeZone = dateStringWithTimeZone.slice(
    dateStringWithTimeZone.lastIndexOf(' ') + 1,
    dateStringWithTimeZone.length,
  )

  return shortTimeZone
}

export default getShortTimeZone
